import './Page.css';
export var detailViewCSS = '_flgwqx3-2-0-1';
export var pageControlButtonIconCSS = '_flgwqx4-2-0-1';
export var pageControlButtonIconFlippedCSS = '_flgwqx5-2-0-1';
export var pageDrawerCSS = '_flgwqx1-2-0-1';
export var pageHeaderCSS = '_flgwqx6-2-0-1';
export var pageMainCSS = '_flgwqx7-2-0-1';
export var pageMainLeftCornersCSS = '_flgwqx8-2-0-1';
export var pageMainRightCornersCSS = '_flgwqx9-2-0-1';
export var pageWrapperCSS = '_flgwqx0-2-0-1';
export var sidebarCSS = '_flgwqx2-2-0-1';